// extracted by mini-css-extract-plugin
module.exports = {"Video-wrapper":"video-wrapper_Video-wrapper__ztEM1"};